export class ArmyListUnitArsenalView {
  count: number;
  max: number;
  unitName: string;
  armyId: string;

  constructor(params: ArmyListUnitArsenalViewParams) {
    this.count = params.count;
    this.max = params.max;
    this.unitName = params.unitName;
    this.armyId = params.armyId;
  }
}

export type ArmyListUnitArsenalViewParams = {
  count: number;
  max: number;
  unitName: string;
  armyId: string;
};
